'use strict';

var angular = require('angular');

// CSS
require('bootstrap-additions/dist/bootstrap-additions.css');

// SASS
require('./styles/app.scss');

require('angular-strap');
require('angular-strap/dist/angular-strap.tpl');

angular
  .module('frontend', [
    // Core
    require('angular-route'),
    require('angular-translate'),
    require('angular-messages'),
    require('angular-animate'),

    'mgcrea.ngStrap',

    // Directives
    require('./app/directives'),

    // Filters
    require('./app/filters'),

    // Global Components
    require('./app/components'),

    // Master & Detail components
    require('./admin'),
    require('./auth'),
    require('./landing'),

    require('./salary'),
    require('./performance-review')
  ])
  .factory('sessionResponseInterceptor', require('./app/providers/session-response-interceptor'))
  .factory('translationLoader', require('./app/providers/translation-loader'))
  .factory('languageService', require('./app/services/language.service'))
  .factory('contactService', require('./app/services/contact.service'))
  .factory('clockService', require('./app/services/clock.service'))
  .factory('errorHandlerService', require('./app/services/errorhandler.service'))
  .config(require('./app/config'));



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.js
 ** module id = 0
 ** module chunks = 0
 **/